export const PROFILE_CONTINUING_EDUCATION_ERROR =
    'PROFILE_CONTINUING_EDUCATION_ERROR';
export const PROFILE_CONTINUING_EDUCATION_LOADING =
    'PROFILE_CONTINUING_EDUCATION_LOADING';
export const PROFILE_CONTINUING_EDUCATION_SUCCESS =
    'PROFILE_CONTINUING_EDUCATION_SUCCESS';